import type { AppRole } from '@/lib/permissions'

export interface InvitePayload {
  company_id: string
  company_name: string
  role: AppRole
  exp: number
}

export function generateInviteToken(payload: Omit<InvitePayload, 'exp'>): string {
  const exp = Date.now() + 7 * 24 * 60 * 60 * 1000
  const data: InvitePayload = { ...payload, exp }
  return btoa(JSON.stringify(data))
}

export function parseInviteToken(token: string): InvitePayload | null {
  try {
    const data = JSON.parse(atob(token)) as InvitePayload
    if (!data.company_id || !data.role || !data.exp) return null
    if (Date.now() > data.exp) return null
    return data
  } catch {
    return null
  }
}

export function buildInviteLink(token: string): string {
  return `${window.location.origin}/register?invite=${encodeURIComponent(token)}`
}
